var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "go-content-wrapper gray" },
    [
      _c("div", { staticClass: "go-container mypage sub" }, [
        _c("div", { staticClass: "go-layout-wrap" }, [
          _c("div", { staticClass: "go-layout-header" }, [
            _c("div", { staticClass: "go-layout-path" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("myPage.common.myPage")))]),
              _vm._v(" "),
              _c("i", { staticClass: "go-icon-16 go-icon-chevron-right" }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("myPage.common.myAccount")))]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "go-layout-title" }, [
              _c(
                "button",
                {
                  staticClass: "btn go-btn-icon",
                  attrs: {
                    type: "button",
                    "data-toggle": "dropdown",
                    "aria-expanded": "false",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.roueToMyPage()
                    },
                  },
                },
                [_c("i", { staticClass: "go-icon-24 go-icon-arrow-left" })]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "go-page-header-type2" }, [
                _c("div", { staticClass: "go-page-title" }, [
                  _vm._v(_vm._s(_vm.$t("myPage.common.myAccount"))),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          !_vm.waitingCallApi
            ? _c("div", { staticClass: "go-layout-content" }, [
                _c("div", { staticClass: "go-panel go-panel-common" }, [
                  _c("div", { staticClass: "go-panel-header" }, [
                    _c("div", { staticClass: "mypage-account" }, [
                      _c("div", { staticClass: "go-user-thumb" }, [
                        _c("img", {
                          attrs: {
                            id: "avatar",
                            src: _vm.user.imageUrl,
                            alt: "",
                          },
                          on: { error: _vm.onErrorImageAvatar },
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn go-btn-default btn-edit",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.openPopupUpload()
                            },
                          },
                        },
                        [_c("i", { staticClass: "go-icon-18 go-icon-edit" })]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        staticClass: "d-none",
                        attrs: {
                          type: "file",
                          accept: "image/*",
                          id: "fileUpload",
                          name: "fileUpload",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.uploadAvatar($event)
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "go-panel-body" }, [
                    _c("div", { staticClass: "go-form-area" }, [
                      _c("div", { staticClass: "go-form-group" }, [
                        _c("label", { staticClass: "go-form-label" }, [
                          _vm._v(_vm._s(_vm.$t("myPage.detail.name"))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "go-input-group" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.user.lastName,
                                expression: "user.lastName",
                              },
                            ],
                            staticClass: "go-form-control",
                            attrs: {
                              type: "text",
                              maxlength: "50",
                              minlength: "1",
                              required: "",
                            },
                            domProps: { value: _vm.user.lastName },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.user,
                                    "lastName",
                                    $event.target.value
                                  )
                                },
                                _vm.refactorLastNameInput,
                              ],
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "go-form-feedback" }, [
                          !_vm.user.lastName
                            ? _c(
                                "small",
                                { staticClass: "form-text text-danger" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "myPage.profile.placeHolderLastnameInput"
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isValidLastName
                            ? _c(
                                "small",
                                { staticClass: "form-text text-danger" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("myPage.profile.requiredValidName")
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.user.email
                        ? _c("div", { staticClass: "go-form-group" }, [
                            _c("label", { staticClass: "go-form-label" }, [
                              _vm._v(_vm._s(_vm.$t("myPage.detail.email"))),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "go-input-group" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.user.email,
                                    expression: "user.email",
                                  },
                                ],
                                staticClass: "go-form-control",
                                attrs: {
                                  type: "email",
                                  readonly: "",
                                  disabled: "",
                                },
                                domProps: { value: _vm.user.email },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.user,
                                      "email",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.user.phoneNumber
                        ? _c("div", { staticClass: "go-form-group" }, [
                            _c("label", { staticClass: "go-form-label" }, [
                              _vm._v(
                                _vm._s(_vm.$t("myPage.detail.phoneNumber"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "go-input-group" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.user.phoneNumber,
                                    expression: "user.phoneNumber",
                                  },
                                ],
                                staticClass: "go-form-control",
                                attrs: {
                                  type: "tel",
                                  readonly: "",
                                  disabled: "",
                                },
                                domProps: { value: _vm.user.phoneNumber },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.user,
                                      "phoneNumber",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.user.phoneNumber || !_vm.user.email
                        ? _c("div", { staticClass: "go-form-group" }, [
                            _c("label", { staticClass: "go-form-label" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.user.email
                                    ? _vm.$t("myPage.setting.phoneNumber")
                                    : "Email"
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "go-btn-block" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn go-btn-default",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openModal()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.user.email
                                          ? _vm.$t(
                                              "myPage.button.editPhoneInfo"
                                            )
                                          : _vm.$t(
                                              "myPage.button.editEmailInfo"
                                            )
                                      ) +
                                      "\n                  "
                                  ),
                                ]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "go-panel-footer" }, [
                    _c("div", { staticClass: "go-btn-between" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn go-btn-default",
                          on: {
                            click: function ($event) {
                              return _vm.goTo("/my-page")
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("myPage.button.cancel")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn go-btn-primary",
                          attrs: {
                            type: "submit",
                            disabled:
                              _vm.isLoadingUpdateUser || _vm.isChangeInfo,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.updateUser()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("myPage.button.save")) +
                              "\n              "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "go-panel go-panel-common sub-nav" }, [
                  _c("div", { staticClass: "go-panel-body" }, [
                    _c("div", { staticClass: "mypage-nav" }, [
                      _c("dl", [
                        _c("dt", [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.$t("myPage.common.resetAccount"))
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("dd", [
                          _c(
                            "button",
                            {
                              staticClass: "btn go-btn-icon",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.goTo("/my-page/detail/reset")
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "go-icon-24 go-icon-chevron-right",
                              }),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("dl", [
                        _c("dt", [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.$t("myPage.common.deleteAccount"))
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("dd", [
                          _c(
                            "button",
                            {
                              staticClass: "btn go-btn-icon",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.goTo("/my-page/detail/delete")
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "go-icon-24 go-icon-chevron-right",
                              }),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("modal-phone-valid", {
        attrs: { "open-modal": _vm.openEditPhone, "is-email": !_vm.user.email },
        on: { close: _vm.closeModal, save: _vm.saveMoreInfo },
      }),
      _vm._v(" "),
      _vm.waitingCallApi ? _c("ListLoading") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }